angular.module('cpm')
    .filter('isCampaign', [ () => {
        'use strict';
        return function(contentType) {
            return contentType === "x-reflow/campaign";
        };
}]);

angular.module('cpm')
    .filter('isVideo', [ () => {
        'use strict';
        return function(contentType) {
            return /^video/.test(contentType);
        };
}]);

angular.module('cpm')
    .filter('isImage', [ () => {
        'use strict';
        return function(contentType) {
            return /^image/.test(contentType);
        };
}]);

angular.module('cpm')
    .filter('isFolder', [ () => {
        'use strict';
        return function(contentType) {
            return contentType === "x-reflow/folder";
        };
}]);

angular.module('cpm')
    .filter('isText', [ () => {
        'use strict';
        return function(contentType) {
            return /^text\//.test(contentType);// && contentType !== "text/html";
        };
}]);

angular.module('cpm')
    .filter('isHmtl', [ () => {
        'use strict';
        return function(contentType) {
            return contentType === "text/html";
        };
}]);

angular.module('cpm')
    .filter('isFlash', [ () => {
        'use strict';
        return function(contentType) {
            return contentType === "application/x-shockwave-flash";
        };
}]);